import { Menu, X } from 'lucide-react';
import { Sidebar } from '../components/layout/Sidebar';
import { MessageList } from '../components/chat/MessageList';
import { MessageInput } from '../components/chat/MessageInput';
import { SettingsPage } from '../components/settings/SettingsPage';
import { SearchPage } from '../components/chat/SearchPage';
import { HelpCenterPage } from './HelpCenterPage';
import { TermsPage } from './TermsPage';
import { Button } from '../components/ui/button';
import { ThemeToggle } from '../components/ui/theme-toggle';
import { useUIStore } from '../stores/uiStore';
import { cn } from '@/lib/utils';

export function ChatPage() {
  const { sidebarOpen, setSidebarOpen, toggleSidebar, currentView } = useUIStore();

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={cn(
          'fixed inset-y-0 left-0 z-50 w-[19rem] overflow-hidden transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        )}
      >
        {/* Mobile Close Button */}
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-2 top-2 md:hidden z-10"
          onClick={() => setSidebarOpen(false)}
        >
          <X className="h-5 w-5" />
        </Button>
        <Sidebar />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col w-full">
        {currentView === 'settings' ? (
          <SettingsPage />
        ) : currentView === 'search' ? (
          <SearchPage />
        ) : currentView === 'help' ? (
          <HelpCenterPage />
        ) : currentView === 'terms' ? (
          <TermsPage />
        ) : (
          <>
            {/* Mobile Header with Menu Button */}
            <div className="flex items-center p-3 border-b md:hidden">
              <Button variant="ghost" size="icon" onClick={toggleSidebar}>
                <Menu className="h-5 w-5" />
              </Button>
              <img src="/logo.png" alt="KI für Pflege" className="h-6 w-auto ml-2" />
            </div>

            {/* Messages */}
            <div className="flex-1 overflow-hidden relative">
              {/* Theme Toggle - floating top right */}
              <div className="absolute top-3 right-3 z-10">
                <ThemeToggle />
              </div>
              <MessageList />
            </div>

            {/* Input */}
            <MessageInput />
          </>
        )}
      </div>
    </div>
  );
}
